<template>
  <div
    ref="weatherTooltip"
    data-bs-toggle="tooltip"
    data-bs-placement="bottom"    
    :title="loadWeather ? weather_name : msg"    
  >
    <!-- Location disabled message -->
    <i v-if="msg" class="fa fa-map-marker-alt" />

    <div 
      v-else
      class="d-flex flex-column flex-sm-row align-items-center gap-2"
    >
      <template v-if="loadWeather">
        <div class="location-name text-uppercase overflow-hidden">
          {{ weather_name }}
        </div>
        <div class="container-weather d-flex justify-content-center flex-shrink-0 align-items-center gap-2">
          <img        
            :src="`img/weather/${weather_icon.toLowerCase()}.png`"
            alt="Clima"
          />
          <span>{{ Math.round(weather_temp) }} °C</span>
        </div>         
      </template>
      
      <!-- Loader -->
      <div 
        v-else 
        class="spinner-grow spinner-grow-sm text-primary"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>  
  </div>
</template>
<script>
import axios from 'axios';
export default {
  name: "WeatherViewer",
  data() {
    return {
      loadWeather: false,
      weather: {},
      weather_icon: "",
      weather_temp: "",
      weather_name: "",
      weather_icon_name: "",
      weather_country: "",
      msg: "",
    };
  },
  mounted() {
    this.getWeather();
  },
  methods: {
    getWeather() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (gps) => {
            let coordinates = gps.coords;
            fetch(
              `https://api.openweathermap.org/data/2.5/weather?lat=${coordinates.latitude}&lon=${coordinates.longitude}&lang=es&units=metric&appid=b079452a19ebe2164110c17a10d1c8ca`
            )
              .then((response) => {
                return response.json();
              })
              .then((dataWeather) => {
                this.loadWeather = true;
                this.weather = dataWeather;
                this.weather_icon = this.weather.weather[0].main;
                this.weather_temp = this.weather.main.temp;
                this.weather_country = this.weather.sys.country;                
                switch (this.weather_icon.toLowerCase()) {
                  case "clear":
                    this.weather_icon_name = "Soleado";
                    break;
                  case "clouds":
                    this.weather_icon_name = "Nublado";
                    break;
                  case "drizzle":
                    this.weather_icon_name = "llovizna";
                    break;
                  case "rain":
                    this.weather_icon_name = "lluvia";
                    break;
                  case "snow":
                    this.weather_icon_name = "Nevada";
                    break;
                  case "thunderstorm":
                    this.weather_icon_name = "Tormenta";
                    break;
                  default:
                    break;
                }

                this.getLocationName(coordinates.latitude, coordinates.longitude);
              })
              .finally(() => {});
          },
          () => {
            this.msg =
              "Para visualizar el pronostico de clima en su ciudad, permita el acceso a su ubicación";

            this.initWeatherTooltip();
          },
          {
            enableHighAccuracy: true,
          }
        );
      } else
        alert(
          "Lo siento, tu navegador no tiene soporte para obtener tu ubicación"
        );
    },

    async getLocationName(latitude, longitude) {
      const url = `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&addressdetails=1&accept-language=es`;

      try {
        const { data } = await axios.get(url);
        
        this.weather_name = (data && data.display_name) || (this.weather && this.weather.name) || 'Ubicación desconocida';          
      } catch {        
        this.weather_name = (this.weather && this.weather.name) || 'Ubicación desconocida';      
      }

      this.initWeatherTooltip();
    },

    initWeatherTooltip() {
      this.$nextTick(() => {
        if (window.bootstrap && this.$refs.weatherTooltip) {
          window.bootstrap.Tooltip.getOrCreateInstance(
            this.$refs.weatherTooltip
          );
        }
      });
    },
  },
};
</script>

<style scoped>
.container-weather img{
  width: 30px;
}
.container-weather span{
  font-size: 14px;
  font-weight: bold;
}
.location-name {
  font-size: 12px;
  font-weight: bold;
  height: 18px;
  max-width: 350px;
  border-left: 1px solid #000;
  padding-left: 15px;
}

@media (max-width: 576px) {
  .location-name {
    border-left: 0;
  }
}
</style>
